import React from "react";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import MyModal from "../Modal";
import MailSendPopup from "../MailSendPopup";
import MyEdit from "./Edit";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
export const EventItem = ({ onDelete, event, onEdit, onMailSend }) => {
  const [showDeleteModal, setShowDeleteModal] = React.useState(false);
  const [showEditForm, setShowEditForm] = React.useState(false);
  const [showMailSend, setShowMailSend] = React.useState(false);

  return (
    <TableRow
      key={event.title}
      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
    >
      <TableCell component="th" scope="row">
        <input type="checkbox" />
      </TableCell>
      <TableCell align="left">
        <Link to={`/certificates/${event.categoryId}/${event.event_id}/`} className="clickable-blue">
          <p>{event.name}</p>
        </Link>
      </TableCell>
      <TableCell align="left">
        <p>{event.description}</p>
      </TableCell>
      <TableCell align="left">
        <h6>{event.eventDate || event.event_date}</h6>
      </TableCell>
      <TableCell align="left">
        <h6>{event.location || 'Not specified'}</h6>
      </TableCell>
      <TableCell align="left">
        <div className="center">
          <Button
            variant="primary"
            size="sm"
            onClick={() => {
              setShowEditForm(true);
            }}
          >
            Edit
          </Button>

          <Button
            variant="primary"
            size="sm"
            onClick={() => {
              setShowMailSend(true);
            }}
          >
            Mail
          </Button>

          <Button
            variant="danger"
            size="sm"
            onClick={() => setShowDeleteModal(true)}
          >
            Delete
          </Button>
        </div>

        <MyEdit
          show={showEditForm}
          onHide={() => setShowEditForm(false)}
          event={event}
          onEdit={onEdit}
          setShowEditForm={setShowEditForm}
        />
        <MyModal
          show={showDeleteModal}
          onCancel={() => setShowDeleteModal(false)}
          onConfirm={() => {
            onDelete(event.event_id);
            setShowDeleteModal(false);
          }}
        />
        <MailSendPopup
          show={showMailSend}
          onCancel={() => {
            setShowMailSend(false);
          }}
          onSendAll={() => {
            onMailSend(event.event_id, true);
            setShowMailSend(false);
          }}
          onSendFiltered={() => {
            onMailSend(event.event_id, false);
            setShowMailSend(false);
          }}
        />
      </TableCell>
    </TableRow>
  );
};
